import './request-info.scss';
import {useIntl} from "react-intl";
import {Field} from 'formik';
import {typeIdentification} from '../../../__mocks__/data';
import _ from 'lodash';
import {WLOCreditAPIService} from '../../../services';
import toast from "react-hot-toast";
import {useLoginContext} from '../../../hooks/useLoginContext';
import {useRequestContext} from '../../../hooks/useRequestContext';
import {ANIPersona, CygnusPersona} from '../../../context/RequestContext';
import {useEffect, useState} from 'react';
import ClockLoader from "react-spinners/ClockLoader";

interface FormKnowYouJuridicaProps {
    errors?: any,
    values?: any,
}

export function FormKnowYouJuridica(props: FormKnowYouJuridicaProps) {
    const {user} = useLoginContext();
    const {request, setRequest} = useRequestContext();
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const {errors, values} = props;
    const intl = useIntl();
    const isBlank = (value?: string) => !value || value.trim() === '';
    const getPolizaFallback = () => {
        const raw = sessionStorage.getItem('datos_Poliza');
        if (!raw) return null;
        try {
            const data = JSON.parse(raw);
            return {
                razonSocial: data.Pws_Nom_socie || ''
            };
        } catch {
            return null;
        }
    };
    const applyPolizaFallback = () => {
        const poliza = getPolizaFallback();
        if (!poliza) return;
        if (isBlank(values.Pws_Nom_socie) && !isBlank(poliza.razonSocial)) {
            values.Pws_Nom_socie = poliza.razonSocial;
        }
    };
    
    useEffect(() => {
        console.log("FormKnowYouJuridica");
        const datosPersonaString = sessionStorage.getItem("personaValidada");
        if (datosPersonaString) {
            const datosPersona = JSON.parse(datosPersonaString);
            const numDoc = datosPersona.numIdenVal;
            const numTipoDoc = datosPersona.tipIdenVal;
            if (numDoc) {
                values.Pws_Identificacion = numDoc;
            }
            if (numTipoDoc) {
                values.Pws_Tip_Identificacion = numTipoDoc;
            }
        }
        handleSearch()
    }, []);

    const handleSearch = async () => {
        setIsLoadingInfo(true);
        const datosPersona = sessionStorage.getItem('personaValidada');
        if (datosPersona) {
            if (!isNaN(values.Pws_Identificacion)) {
                try {
                    // Aquí deberías implementar la lógica específica para consulta de personas jurídicas
                    // Esto es solo un ejemplo, adapta según tu API
                    const companyInfo = await WLOCreditAPIService.consultaRues(values.Pws_Identificacion!,
                        values.Pws_Matricula!
                     );

                       
                    const personj = await WLOCreditAPIService.consultaSolicitudPJ({
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                        Pws_Identificacion: values.Pws_Identificacion!
                    });
                    console.log("persona", personj);
                    console.log(personj.payload.data.Resultado)
                    if (!_.isEmpty(personj.payload?.data.datos_jur?.Datos_per_jur[0])) {
                        
                        if (personj.payload?.data?.Resultado == "1" ) {
                            const pjCygnus = personj?.payload?.data.datos_jur?.Datos_per_jur[0] ;
                            values.Pws_Nom_socie=pjCygnus.nom_socie;
                            values.Pws_Tip_Identificacion=pjCygnus.tipo_identificacion;
                            values.Pws_Fec_cre=pjCygnus?.fec_crea?.split("-00")[0];
                            values.Pws_Cod_ciu=pjCygnus.cod_ciu;
                            values.Pws_act_eco=pjCygnus.cod_ciu;
                            values.Pws_tip_emp=pjCygnus.tip_emp;

                            values.Pws_Act_finan=pjCygnus.activo_jur;
                            values.Pws_Pasiv_finan=pjCygnus.pas_jur;
                            values.Pws_ingres_finan=pjCygnus.ingre_jur;
                            values.Pws_egres_finan=pjCygnus.egre_jur;

                            values.Pws_tip_contri=pjCygnus.tip_contribu;
                            values.Pws_auto_rete=pjCygnus.auto_rete;
                            values.Pws_ret_iva=pjCygnus.ret_iva;

                            values.Pws_Direccion=pjCygnus.Direccion;
                            values.Pws_Ciudad=pjCygnus.Ciudad_residencia;

                            

                          
                            setRequest({...request, personCygnus: pjCygnus, searchANI: false, errorConsulta: false});
                            sessionStorage.setItem('person', JSON.stringify(personj.payload.data.datos_jur.Datos_per_jur[0]));
                            setIsLoadingInfo(false);

                            const repLegal:any = await WLOCreditAPIService.consultaSolicitudCygnus({ Pws_Identificacion: pjCygnus.iden_repre_legal,  Pws_Tip_Identificacion: "1"});
                            
                            console.log("repLegal", repLegal);
                            if (Number(repLegal.payload.result) > 0) {
                                if (repLegal.payload.data.datos_persona.Datos_persona.length > 0) {
                                    //valor.payload.data.datos_persona.Datos_persona[0]
                                    const personCygnus: CygnusPersona = repLegal.payload.data.datos_persona.Datos_persona[0];
                                    values.Pws_i_codigo = personCygnus.Pws_i_codigo;
                                    values.Pws_Rep_Legal_Nombres=personCygnus.Pws_Nombres;
                                    values.Pws_Rep_Legal_Apellidos=personCygnus.Pws_Apellidos1 + " " + personCygnus.Pws_Apellidos2;
                                    values.Pws_Rep_Legal_Tipo_ID=personCygnus.Pws_Tip_Identificacion;
                                    values.Pws_Rep_Legal_Identificacion=personCygnus.Pws_Identificacion;
                                    values.Pws_Rep_Legal_Lugar_Exp=personCygnus.Pws_Lugar_exp;
                                    values.Pws_Rep_Legal_Fecha_Exp=personCygnus.Pws_Fec_expe.split("-00")[0];
                                    values.Pws_Rep_Legal_Direccion=personCygnus.Pws_Direccion_res;
                                    values.Pws_Rep_Legal_Telefono=personCygnus.Pws_Telefono1;
                                    values.Pws_Rep_Legal_Correo=personCygnus.Pws_Correo;
                                    values.Pws_Rep_Legal_Ciudad=personCygnus.Pws_Ciudad_res;
                                    values.Pws_Rep_Legal_I_Codigo=repLegal.payload.data.datos_persona.Datos_persona[0].Pws_i_codigo;
                                    values.Pws_telefono=pjCygnus.Telefono1;
                                    values.Pws_correo=personCygnus.Pws_Correo;
                          
 
                                }
                            }
                        }
                    } else {
                        applyPolizaFallback();
                    }
                   
                   /*  const companyInfo = await WLOCreditAPIService.consultaEmpresa({
                        Pws_Tip_Identificacion: values.Pws_Tip_Identificacion!,
                        Pws_Identificacion: values.Pws_Identificacion!
                    }); */
                    
                    if (companyInfo.payload && companyInfo.payload.flag) {
                        //DESCOMENTAR CUANDO SE TENGA LA RESPUESTA DE LA API
                        //values.Pws_Nom_socie = companyInfo.payload.data.razon_social;
                        
                        // Otros campos específicos para jurídica
                        setIsLoadingInfo(false);
                    } else {
                        toast.error('No se encontró información de la empresa', {
                            duration: 5000,
                        });
                        applyPolizaFallback();
                        setIsLoadingInfo(false);
                    }
                } catch (e) {
                    const error = e as any;
                    setRequest({...request, errorConsulta: true});
                    toast.error(error.response?.data?.message || 'Error al consultar la empresa', {
                        duration: 5000,
                    });
                    console.log("Error al consultar empresa", error);
                    applyPolizaFallback();
                    setIsLoadingInfo(false);
                }
            } else {
                toast.error("El NIT debe ser numérico", {
                    duration: 5000,
                });
                setIsLoadingInfo(false);
            }
        }
    }

    return (
        <div className={'row'}>
            <ClockLoader id='spinner' color={"#009694"} loading={isLoadingInfo} size={100}/>
            <div className={"title-medium-red"}>{intl.formatMessage({id: "form_credit_information_title"})}</div>
            <div className={"subtitle-medium"}>{intl.formatMessage({id: "form_credit_information_subtitle"})}</div>
            
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field as="select"
                        id={"Pws_Tip_Identificacion"}
                        name={"Pws_Tip_Identificacion"}
                        className={`${errors.Pws_Tip_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        disabled>
                        {/* Filtra solo el tipo NIT si es necesario */}
                        {typeIdentification && typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion
                            .filter(item => item.s_codigo === 3) // Ajusta según tu código para NIT
                            .map((item, key: number) => (
                                <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                            ))}
                    </Field>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Identificacion"}
                        name={"Pws_Identificacion"}
                        disabled
                        className={`${errors.Pws_Identificacion ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder="NIT"/>
                </div>
            </div>
            
            {/* Campo específico para razón social en lugar de nombres/apellidos */}
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-6"}>
                    <Field id={"Pws_Nom_socie"}
                        name={"Pws_Nom_socie"}
                        //disabled
                        className={`${errors.Pws_Nom_socie ? 'form-know-you-item-input-large input-error' : 'form-know-you-item-input-large'}`}
                        placeholder={"Razón Social"}/>
                </div>
            </div>
            
            {/* Resto de campos (teléfonos, email) se mantienen similares */}
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono1"}
                        name={"Pws_Telefono1"}
                        className={`${errors.Pws_Telefono1 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_1"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"Pws_Correo"}
                        name={"Pws_Correo"}
                        className={`${errors.Pws_Correo ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_mail"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-right flex-grow-6"}>
                    <Field id={"Pws_Telefono2"}
                        name={"Pws_Telefono2"}
                        className={`${errors.Pws_Telefono2 ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                        placeholder={intl.formatMessage({id: "placeholder_phone_2"})}/>
                </div>
                <div className={"flex-container-form-know-you-item-left flex-grow-6"}>
                    <Field id={"mail_confirmation"}
                    onPaste={(e:any)=>{
                        e.preventDefault()
                        return false;
                    }} 
                    autoComplete="off"
                    name={"mail_confirmation"}
                    className={`${errors.mail_confirmation ? 'form-know-you-item-input-small input-error' : 'form-know-you-item-input-small'}`}
                    placeholder={intl.formatMessage({id: "placeholder_mail_confirmation"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-6"}>
                    <Field id={"Num_poliza"}
                        name={"Num_poliza"}
                        className={`${errors.Num_poliza ? 'form-know-you-item-input-large input-error' : 'form-know-you-item-input-large'}`}
                        placeholder={"Numero de poliza"}/>
                </div>
            </div>
        
        </div>
    )
}